import { LitElement, html, css, unsafeCSS, property } from 'lit-element';

import horizontalBarMeterStyles from './horizontal-bar-meter.scss';
import HighlightRule from '../../enums/highlight-rule';
import { StratusStatsCardComponentTemplateModel } from '../../models/components/StratusStatsCardComponentTemplateModel';

class BarAnimationModel {
    public Width: number;
    public CurrentWidth: number;
    public Step: number;
    public Animate: Function;
    public Control: HTMLElement;

    constructor(width, control, animate) {
        this.Width = width;
        this.CurrentWidth = 0;
        this.Animate = animate;
        this.Control = control;
        this.Step = this.Width / 30;
    }
}

export default class HorizontalBarMeter extends LitElement {
    private _data: StratusStatsCardComponentTemplateModel;
    private _middleStart: boolean;
    private _onClick: Function;
    private _playlistClickThrough: boolean;

    constructor(data: StratusStatsCardComponentTemplateModel, middleStart: boolean, playlistClickThrough: boolean, onClick: Function) {
        super();

        this._data = data;
        this._middleStart = middleStart;
        this._onClick = onClick;
        this._playlistClickThrough = playlistClickThrough;
    }

    static get styles() {
        return [
            css`${unsafeCSS(horizontalBarMeterStyles)}`
        ]
    }

    firstUpdated() {
        let homeTeamControl = this.shadowRoot.querySelector(`.home-team`);
        let awayTeamControl = this.shadowRoot.querySelector(`.away-team`);

        let homeTeamAnimation = new BarAnimationModel(this._data.homeTeam.percentageValue, homeTeamControl, this.animateBar);
        homeTeamAnimation.Animate(homeTeamAnimation);

        let awayTeamAnimation = new BarAnimationModel(this._data.awayTeam.percentageValue, awayTeamControl, this.animateBar);
        awayTeamAnimation.Animate(awayTeamAnimation);
    }

    animateBar(model: BarAnimationModel) {
        model.Control.style.width = `${model.CurrentWidth}%`;
        model.CurrentWidth += model.Step;

        if (model.CurrentWidth < model.Width) {
            requestAnimationFrame(function () {
                model.Animate(model);
            });
        } else if (model.CurrentWidth >= model.Width)
            model.Control.style.width = `${model.Width}%`;
    }

    getBarFills() {
        let barFills = html``;

        if (this._middleStart) {
            barFills = html`<div class="middle-start">
                                <div class="home-team" style='--home-team-highlight-color: ${this._data.homeTeam.highlightColor};'>&nbsp;</div>
                            </div>
                            <div class="middle-start">
                                <div class="away-team" style='--away-team-highlight-color: ${this._data.awayTeam.highlightColor};'>&nbsp;</div>
                            </div>`;
        } else {
            barFills = html`<div class="home-team" style='--home-team-highlight-color: ${this._data.homeTeam.highlightColor};'>&nbsp;</div>
            <div class="away-team" style='--away-team-highlight-color: ${this._data.awayTeam.highlightColor};'>&nbsp;</div>`;
        }

        return barFills;
    }

    render() {
        let hightlightOptions = HighlightRule.CalculateHighlightOption(this._data.highlightRule, this._data.homeTeam, this._data.awayTeam);

        return [
            html`
                <div class="headings">
                    <div @click="${async (event) => await this._onClick(event, this._data.homeTeam.metricId, this._data.homeTeam.id, this._data.heading)}" 
                        class="percentage ${(this._playlistClickThrough ? "clickable" : "")} left ${(hightlightOptions.homeTeam ? "highlight" : "")}"
                        title="${this._data.heading}">${this._data.homeTeam.displayValue}</div>
                    <div><h5>${this._data.heading}</h5></div>
                    <div @click="${async (event) => await this._onClick(event, this._data.awayTeam.metricId, this._data.awayTeam.id, this._data.heading)}" 
                        class="percentage ${(this._playlistClickThrough ? "clickable" : "")} right ${(hightlightOptions.awayTeam ? "highlight" : "")}"
                        title="${this._data.heading}">${this._data.awayTeam.displayValue}</div>                    
                </div>
                <div class="progress">
                    <div class="bar" style='--bar-base-color: ${this._data.baseColor}'>
                        ${this.getBarFills()}                        
                    </div>
                </div>
            `
        ]
    }
}

window.customElements.define('horizontal-bar-meter', HorizontalBarMeter as any);